import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * Reusable page-level header: title, optional subtitle, and a right-side
 * actions slot via <ng-content select="[actions]">.
 *
 * Usage:
 *   <app-page-header title="E-Stamp" subtitle="Create a new stamp">
 *     <div actions>
 *       <app-button label="New Order" (clicked)="newOrder()"></app-button>
 *     </div>
 *   </app-page-header>
 */
@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageHeaderComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() showDivider: boolean = true;
}
